import React from 'react';
import _ from 'lodash';
import SchemaForm from 'app/components/general/SchemaForm';
import SectionGroup from 'app/components/general/SectionGroup';
import HeaderThin from 'app/components/layout/HeaderThin';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as competitionActions from 'app/ducks/competitions/actions';

import * as competitionSelectors from 'app/ducks/competitions/selectors';
import Button from 'app/components/general/Button';

const formSchema = {
  type: 'object',
  required: ['name', 'friendlyCode'],
  properties: {
    name: {
      type: 'string',
      title: 'Name',
    },
    friendlyCode: {
      type: 'string',
      title: 'Code (short competition code/acronym)',
      minLength: 2,
    },
    seasonName: {
      type: 'string',
      title: 'Season',
    },
    seasonStartAt: {
      type: 'array',
      items: {
        type: 'string',
      },
      enableTime: false,
      inputType: 'datetime',
      title: 'Start Date',
    },
    seasonEndAt: {
      type: 'array',
      items: {
        type: 'string',
      },
      enableTime: false,
      inputType: 'datetime',
      title: 'End Date',
    },
    externalSystemName: {
      type: 'string',
      title: 'Competition Name (In fixture system)',
    },
  },
};

const uiSchema = {
  status: { 'ui:field': 'select', classNames: 'col' },
  seasonStartAt: { 'ui:field': 'datetime' },
  seasonEndAt: { 'ui:field': 'datetime' },
  archived: { 'ui:field': 'boolean' },
};

const selector = (state) => ({
  competitions: competitionSelectors.getCompetitions(state),
  errors: { ...state.competitions.backendErrors },
});

const actionCreators = _.merge(competitionActions);

interface IDuplicateCompetitionProps {
  appReady: boolean;
  actions: any;
  currentCompetition: any;
  currentCompetitionId: string;
  competitions: any;
  errors: any;
  backendErrors: any;
  match: any;
  teamId: string;
  afterSubmit: Function;
}

export interface IDuplicateCompetitionState {
  originalFormData: any;
  formData: any;
  changed: boolean;
  saved: boolean;
  reset: boolean;
  errors: any;
}

const statuses = [
  {
    id: 'active',
    name: 'Active',
  },
  {
    id: 'inactive',
    name: 'Inactive',
  },
];

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class DuplicateCompetition extends React.Component<
  IDuplicateCompetitionProps,
  IDuplicateCompetitionState
> {
  static defaultProps: IDuplicateCompetitionProps = {
    appReady: false,
    actions: undefined,
    match: undefined,
    currentCompetition: {},
    currentCompetitionId: undefined,
    competitions: undefined,
    backendErrors: undefined,
    errors: undefined,
    teamId: undefined,
    afterSubmit: undefined,
  };

  state: IDuplicateCompetitionState = {
    originalFormData: {},
    formData: {},
    changed: false,
    saved: false,
    reset: false,
    errors: {},
  };

  componentDidMount(): void {
    // this.props.actions.getCompetition(this.props.match.params.competitionId);
  }

  static getDerivedStateFromProps(nextProps, prevState): any {
    if (!prevState.changed || nextProps.currentCompetition.id !== prevState.formData.id) {
      const status = _.find(statuses, {
        id: nextProps.currentCompetition.status,
      });
      const formData = {
        id: nextProps.currentCompetition.id,
        name: `${nextProps.currentCompetition.name} (Copy)` || '',
        seasonName: nextProps.currentCompetition.seasonName || '',
        externalSystemName: nextProps.currentCompetition.externalSystemName || '',
        friendlyCode: nextProps.currentCompetition.friendlyCode || '',
        seasonStartAt: [nextProps.currentCompetition.seasonStartAt] || [],
        seasonEndAt: [nextProps.currentCompetition.seasonEndAt] || [],
        status: status || null,
        archived: nextProps.currentCompetition.archived || false,
      };
      return {
        ...prevState,
        formData,
        originalFormData: {},
        errors: nextProps.errors,
        changed: true,
      };
    }
    return null;
  }

  isValid = (): boolean => _.isEmpty(this.state.errors) && this.state.changed;

  handleChange = (e): void => {
    const changed = this.state.originalFormData !== e.formData;
    this.setState(() => ({
      formData: e.formData,
      errors: [],
      changed,
    }));
  };

  handleError = (errors): void => {
    this.setState({ errors });
  }

  handleSubmit = (e): void => {
    // console.log(e);
    // e.preventDefault();

    if (this.isValid()) {
      const payload = {
        id: this.props.currentCompetition.id,
        name: this.state.formData.name,
        seasonName: this.state.formData.seasonName,
        externalSystemName: this.state.formData.externalSystemName,
        friendlyCode: this.state.formData.friendlyCode,
        seasonStartAt: this.state.formData.seasonStartAt[0],
        seasonEndAt: this.state.formData.seasonEndAt[0],
        archived: this.state.formData.archived,
        status: !_.isEmpty(this.state.formData.status)
          ? this.state.formData.status.id
          : null,
        organisation: {
          id: this.props.currentCompetition.organisation.id,
        },
        featureFlags: this.props.currentCompetition.featureFlags,
      };
      this.props.actions.duplicateCompetition(payload);
    }
    this.setState({ changed: false });
  };


  render(): React.ReactNode {
    return (
      <SchemaForm
        uiSchema={uiSchema}
        schema={formSchema}
        handleChange={this.handleChange}
        handleError={this.handleError}
        handleSubmit={this.handleSubmit}
        formData={this.state.formData}
        isValid={this.isValid()}
        // showAddAnotherButton
        isLoading={this.props.competitions.isSaving}
        hasSaved={this.props.competitions.hasSaved}
        hasFailed={this.props.competitions.hasFailed}
        originalFormData={this.state.originalFormData}
      />
    );
  }
}
